import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import { JobPhase } from "generated/graphql";
import { PlantRow, denseTableSx, headerCellSx } from "./utils";

export default function MaterialsTable({
  plantRows,
  jobPhase,
}: {
  plantRows: PlantRow[];
  jobPhase: JobPhase;
}) {
  const hasMaterialNoPlants =
    jobPhase?.jobPhaseMaterialNoPlants && jobPhase.jobPhaseMaterialNoPlants.length > 0;

  return (
    <MDBox mb={3} sx={{ "@media print": { marginBottom: 1 } }}>
      <TableContainer component={Paper}>
        <Table aria-label="materials" sx={denseTableSx}>
          <TableBody>
            {plantRows.length > 0 ? (
              <>
                <TableRow>
                  <TableCell variant="head" sx={headerCellSx}>
                    Plant
                  </TableCell>
                  <TableCell variant="head" sx={headerCellSx}>
                    Address
                  </TableCell>
                  <TableCell variant="head" sx={headerCellSx}>
                    Material
                  </TableCell>
                  <TableCell variant="head" align="right" sx={headerCellSx}>
                    Tons
                  </TableCell>
                  <TableCell variant="head" align="right" sx={headerCellSx}>
                    Truck
                  </TableCell>
                  <TableCell variant="head" align="right" sx={headerCellSx}>
                    # of Trucks
                  </TableCell>
                </TableRow>
                {plantRows.map((row) => (
                  <TableRow key={row.key}>
                    <TableCell>{row.plantName}</TableCell>
                    <TableCell>{row.address || "—"}</TableCell>
                    <TableCell>
                      <Typography variant="body2" color="textSecondary">
                        {row.material}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">{row.tons}</TableCell>
                    <TableCell align="right">{row.truckName}</TableCell>
                    <TableCell align="right">{row.truckCount}</TableCell>
                  </TableRow>
                ))}
              </>
            ) : hasMaterialNoPlants ? (
              <>
                <TableRow>
                  <TableCell variant="head" sx={headerCellSx}>
                    Material
                  </TableCell>
                  <TableCell variant="head" align="right" width="72px" sx={headerCellSx}>
                    Quantity
                  </TableCell>
                </TableRow>
                {jobPhase.jobPhaseMaterialNoPlants.map((material) => (
                  <TableRow key={material.id}>
                    <TableCell>{material.name}</TableCell>
                    <TableCell align="right">{material.quantity}</TableCell>
                  </TableRow>
                ))}
              </>
            ) : (
              <TableRow>
                <TableCell variant="head" sx={headerCellSx}>
                  Materials
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}
